import { Delete, Get, Patch, Post } from "./apiHelper";
import { IAttendanceSummaryRow } from "../interfaces/AttendanceInterface";
import { ApiResponse } from "../interfaces/Api";

const attendanceRoot = "/api/attendance";
const attendanceSummariesRoot = "/api/attendanceSummaries";

// post attendance
export async function postAttendance(data: Record<string, unknown>): Promise<ApiResponse<any>> {
  const response = await Post(`${attendanceRoot}`, data, true);
  return response.data as ApiResponse<any>;
}

// patch attendance
export async function patchAttendance({
  id,
  data
}: {
  id: number | string;
  data: Record<string, unknown>;
}): Promise<ApiResponse<any>> {
  const response = await Patch(`${attendanceRoot}/${id}`, data, true);
  return response.data as ApiResponse<any>;
}

// delete attendance
export async function deleteAttendance(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${attendanceRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}

// revised api
export async function getUserAttendanceOfAUser({
  userId,
  resourceCentreId,
  fromDate,
  toDate,
  authenticable
}: {
  userId: number | string;
  resourceCentreId: number | string;
  fromDate: Date;
  toDate: Date;
  authenticable: string;
}): Promise<ApiResponse<Array<any>>> {
  const queryParams = new URLSearchParams();
  queryParams.append("resourceCentreId", resourceCentreId.toString());
  queryParams.append("fromDate", fromDate.toISOString());
  queryParams.append("toDate", toDate.toISOString());
  queryParams.append("authenticable", authenticable);
  const response = await Get(`${attendanceRoot}/user/${userId}?${queryParams.toString()}`, true);

  return response.data as ApiResponse<Array<any>>;
}

// get attendances by admin
export async function getAttendancesByRcAdmin({
  employeeIds,
  serviceProviderIds,
  fromDate,
  untilDate
}: {
  employeeIds?: number[];
  serviceProviderIds?: number[];
  date?: string;
  fromDate?: string;
  untilDate?: string;
}): Promise<ApiResponse<Array<any>>> {
  const queryParams = new URLSearchParams();

  if (fromDate) {
    queryParams.append("fromDate", fromDate);
  }
  if (untilDate) {
    queryParams.append("untilDate", untilDate);
  }

  if (employeeIds && employeeIds.length > 0) {
    queryParams.append("employeeIds", employeeIds.join(","));
  }
  if (serviceProviderIds && serviceProviderIds.length > 0) {
    queryParams.append("serviceProviderIds", serviceProviderIds.join(","));
  }

  const url = `${attendanceRoot}/?${queryParams.toString()}`;

  const response = await Get(url, true);
  return response.data as ApiResponse<Array<any>>;
}

// get attendance summary
export async function getAttendanceSummary({
  resourceCentreId,
  employeeIds = [],
  serviceProviderIds = [],
  fromDate,
  toDate
}: {
  resourceCentreId: number | string;
  employeeIds?: number[];
  serviceProviderIds?: number[];
  fromDate: string;
  toDate: string;
}): Promise<ApiResponse<IAttendanceSummaryRow[]>> {
  const queryParams = new URLSearchParams();
  queryParams.append("resourceCentreId", resourceCentreId.toString());
  queryParams.append("fromDate", fromDate);
  queryParams.append("toDate", toDate);

  if (employeeIds && employeeIds.length > 0) {
    queryParams.append("employeeIds", employeeIds.join(","));
  }
  if (serviceProviderIds && serviceProviderIds.length > 0) {
    queryParams.append("serviceProviderIds", serviceProviderIds.join(","));
  }

  const response = await Get(`${attendanceSummariesRoot}?${queryParams.toString()}`, true);
  return response.data as ApiResponse<IAttendanceSummaryRow[]>;
}
